import React from "react"
import WatermarkSection from "../Decor/WatermarkSection"

export default function MisionVision() {
  return (
    <WatermarkSection size={320}>
      <h2 className="text-2xl md:text-3xl font-extrabold">
        Nuestro Compromiso
      </h2>

      <div className="grid md:grid-cols-2 gap-6 mt-6">
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 border rounded-2xl p-5">
          <h3 className="font-semibold text-amber-800 mb-1">
            🎯Nuestra Misión
          </h3>
          <p className="text-sm text-gray-700">
            Conectar de manera eficiente a consumidores y empresas en Venezuela,
            facilitando el acceso a una amplia gama de productos y servicios,
            optimizando la búsqueda por ubicación y precio, y fomentando el
            crecimiento del comercio local.
          </p>
        </div>

        <div className="bg-gradient-to-br from-sky-50 to-indigo-50 border rounded-2xl p-5">
          <h3 className="font-semibold text-indigo-800 mb-1">
            {" "}
            🧭Nuestra Visión
          </h3>
          <p className="text-sm text-gray-700">
            Ser la plataforma líder en Venezuela para la búsqueda y comparación
            de productos y servicios, reconocida por su innovación,
            confiabilidad y por impulsar la economía digital, transformando la
            experiencia de compra y venta para todos.
          </p>
        </div>
      </div>

      <div className="mt-6 bg-gradient-to-br from-emerald-50 to-teal-50 border rounded-2xl p-5">
        <h3 className="font-semibold text-emerald-800 mb-2">
          💡Nuestros Objetivos
        </h3>
        <ul className="text-sm text-gray-700 list-disc pl-5 space-y-1">
          <li>
            Facilitar la visibilidad de productos y servicios de empresas de
            todos los tamaños.
          </li>
          <li>
            Ofrecer herramientas de búsqueda avanzadas para una experiencia de
            usuario óptima.
          </li>
          <li>
            Proporcionar análisis de mercado y estadísticas a empresas
            afiliadas.
          </li>
          <li>
            Garantizar la transparencia en precios y ubicación para los
            consumidores.
          </li>
          <li>Impulsar la digitalización del comercio venezolano.</li>
        </ul>
      </div>
    </WatermarkSection>
  )
}
